/* ==========================================================================
   BLANKS COMPARATOR V2 — modal opening logic
   Opens the full-screen modal from any #comparator link or URL, and loads the
   <blanks-comparator-v2> element script only on first use.
   ========================================================================== */
(function () {
  'use strict';

  var dialog = document.getElementById('blanks-comparator-v2');
  if (!dialog) return;
  var element = dialog.querySelector('blanks-comparator-v2');
  var loading = null;

  /* --- Element script, loaded once ---
     Added as a <script type="module"> tag rather than with import(): Shopify's CDN minifier rewrites
     import() into require() in a classic script like this one, which breaks outside the local dev server. */
  function loadElement() {
    if (!loading) {
      loading = new Promise(function (resolve, reject) {
        var script = document.createElement('script');
        script.type = 'module';
        script.src = dialog.dataset.elementSrc;
        script.onload = resolve;
        script.onerror = function () {
          script.remove();
          reject(new Error('Script du comparateur introuvable : ' + script.src));
        };
        document.head.appendChild(script);
      })
        .then(function () { return customElements.whenDefined('blanks-comparator-v2'); })
        .catch(function (error) {
          loading = null; // the next opening tries again
          throw error;
        });
    }
    return loading;
  }

  /* --- Close the navigation the link may have been clicked from --- */
  function closeNavigation() {
    var mobileNav = document.getElementById('header-sidebar-menu');
    if (mobileNav && mobileNav.open) {
      mobileNav.close();
      document.body.classList.remove('mobile-nav-open');
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.overflow = '';
    }
    document.querySelectorAll('header details[open]').forEach(function (details) {
      details.removeAttribute('open');
    });
  }

  /* --- Open, optionally with a blank to add to the comparison --- */
  function open(handle) {
    closeNavigation();
    var styles = document.querySelector('[data-cmp2-modal-styles]');
    if (styles) styles.media = 'all';
    if (!dialog.open) {
      dialog.showModal();
      document.documentElement.classList.add('cmp2-modal-open');
    }
    // Activated after showModal(): the chart needs its on-screen size.
    loadElement()
      .then(function () { return handle ? element.preselect(handle) : element.activate(); })
      .catch(function (error) {
        console.error('Comparateur V2 :', error); // keep the cause visible, the message below is generic
        var empty = element.querySelector('[data-cmp2="empty"]');
        if (empty) empty.textContent = dialog.dataset.loadError;
      });
  }

  dialog.addEventListener('close', function () {
    document.documentElement.classList.remove('cmp2-modal-open');
  });

  dialog.addEventListener('click', function (event) {
    if (event.target.closest('[data-cmp2-modal-close]')) dialog.close();
  });

  /* --- Any #comparator link site-wide --- */
  document.addEventListener('click', function (event) {
    var link = event.target.closest(
      'a[href="#comparator"], a[href$="#comparator"], ' +
      'summary[data-url="#comparator"], summary[data-url$="#comparator"]'
    );
    if (!link) return;
    event.preventDefault();
    if (link.tagName === 'SUMMARY') {
      var details = link.closest('details');
      if (details) details.removeAttribute('open');
    }
    open(link.getAttribute('data-preselect-blank-handle') || null);
  });

  /* --- Direct URL ending with #comparator --- */
  function checkHash() {
    if (window.location.hash !== '#comparator') return;
    open(null);
    history.replaceState(null, '', window.location.pathname + window.location.search);
  }

  window.addEventListener('hashchange', checkHash);
  checkHash();
})();
